/* Tienda Flashs - landing de producto: calculadora de tamaño (tf-lp-calc) y comparador antes/después (tf-lp-ba).
   No depende de tf-lp.js; las animaciones de aparición siguen viniendo de tf-lp.js. */
(function () {
  if (window.__tfLp2) return;
  window.__tfLp2 = true;

  function fmt(n, dec) {
    return n.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }

  function initCalc(root) {
    root.querySelectorAll('.tf-lp-calc').forEach(function (sec) {
      if (sec.__tfDone) return;
      sec.__tfDone = true;
      var range = sec.querySelector('.tf-lp-calc__range');
      if (!range) return;
      var ratio = parseFloat(sec.getAttribute('data-ratio')) || 1.2;
      var minIn = parseFloat(sec.getAttribute('data-min-in')) || 0;
      var maxIn = parseFloat(sec.getAttribute('data-max-in')) || 300;
      var tpl = sec.getAttribute('data-tpl') || '';
      var tplMax = sec.getAttribute('data-tpl-max') || '';
      var tplMin = sec.getAttribute('data-tpl-min') || '';
      var out = sec.querySelector('.tf-lp-calc__dist');
      var inches = sec.querySelector('.tf-lp-calc__inches');
      var size = sec.querySelector('.tf-lp-calc__size');
      var msg = sec.querySelector('.tf-lp-calc__msg');
      var screen = sec.querySelector('.tf-lp-calc__screen');
      var lbl = sec.querySelector('.tf-lp-calc__screen-lbl');

      function update() {
        var d = parseFloat(range.value);
        var ancho = d / ratio;                       // metros
        var diag = Math.round(ancho / 0.8716 / 0.0254); // pulgadas, formato 16:9
        var shown = Math.max(minIn, Math.min(maxIn, diag));
        var w = Math.min(ancho, (maxIn * 0.0254) * 0.8716);
        var dTxt = fmt(d, 1);
        out.textContent = dTxt + ' m';
        inches.textContent = shown;
        lbl.textContent = shown + '"';
        size.textContent = fmt(w, 1) + ' × ' + fmt(w * 0.5625, 1) + ' m';
        var text;
        if (diag > maxIn) text = tplMax.replace('[max]', maxIn);
        else if (diag < minIn) text = tplMin.replace('[min]', minIn);
        else text = tpl.replace('[d]', dTxt).replace('[in]', diag);
        msg.textContent = text;
        screen.style.setProperty('--pct', (shown / maxIn * 100).toFixed(1) + '%');
        var min = parseFloat(range.min), max = parseFloat(range.max);
        range.style.setProperty('--fill', ((d - min) / (max - min) * 100).toFixed(1) + '%');
        range.setAttribute('aria-valuetext', dTxt + ' metros, ' + shown + ' pulgadas');
      }
      range.addEventListener('input', update);
      update();
    });
  }

  function initBA(root) {
    root.querySelectorAll('.tf-lp-ba__frame').forEach(function (frame) {
      if (frame.__tfDone) return;
      frame.__tfDone = true;
      var range = frame.querySelector('.tf-lp-ba__range');
      if (!range) return;
      function set(v) { frame.style.setProperty('--pos', v + '%'); }
      range.addEventListener('input', function () { set(range.value); });
      set(range.value);
      // Pista de movimiento la primera vez que se ve.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { frame.classList.add('tf-lp-hint'); io.unobserve(frame); }
          });
        }, { threshold: 0.5 });
        io.observe(frame);
      }
    });
  }

  function init(root) { initCalc(root); initBA(root); }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { if (e.target) init(e.target); });
})();
